module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochd"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Author"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Abbreviations"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Dramatis"
    }
  }, [_vm._v("Dramatis Personae")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Foreword"
    }
  }, [_vm._v("Foreword, by Nigel West")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter1"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 1")]), _vm._v(" Arms and the Man")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 2")]), _vm._v(" ‘The man’s keen!’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 3")]), _vm._v(" Going Dutch")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 4")]), _vm._v(" BALLOON’s Report on Holland")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 5")]), _vm._v(" The Air Ministry Leaks")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 6")]), _vm._v(" ‘A man of intelligence and resource’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 7")]), _vm._v(" A Network Evolves")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 8")]), _vm._v(" Plan MIDAS")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 9")]), _vm._v(" BALLOON’s Reports")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 10")]), _vm._v(" Plan STENCH")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 11")]), _vm._v(" The ‘mythical Christmas card’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 12")]), _vm._v(" ‘Gardiner is all right’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 13")]), _vm._v(" The Scandinavian Connection")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 14")]), _vm._v(" ‘A sub-machine gun of outstanding design’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 15")]), _vm._v(" A thorn in BALLOON’s side")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 16")]), _vm._v(" The Grand, Cliveley and Postnikow Affair")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 17")]), _vm._v(" ‘It is clear that B is in debt’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 18")]), _vm._v(" Correspondence")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 19")]), _vm._v(" The BALLOON Traffic (Part 1)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 20")]), _vm._v(" The TRIBAGE Organisation")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 21")]), _vm._v(" The BALLOON Traffic (Part 2)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 22")]), _vm._v(" ‘Plan A’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 23")]), _vm._v(" ‘I regard this as very naughty of BALLOON’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 24")]), _vm._v(" Cover Addresses")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 25")]), _vm._v(" Going nowhere")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 26")]), _vm._v(" ‘He continues to provide such information …’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 27")]), _vm._v(" ‘A man of intelligence and resource’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0